import { render, staticRenderFns } from "./confirmaregreso.vue?vue&type=template&id=71eab650"
import script from "./confirmaregreso.vue?vue&type=script&lang=js"
export * from "./confirmaregreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports